<ng-container>
    <mat-expansion-panel class="catalog-expansion-panel" [disabled]="disabled">
        <mat-expansion-panel-header>
            <h2>{{ label }}</h2>
        </mat-expansion-panel-header>
        <mat-checkbox *ngFor="let filter of filterItems"
            [value]="filter.id"
            [checked]="filter.selected"
            [disabled]="filter.disabled || disabled" 
            (change)="valueChange($event)">
            {{ filter.name }}
        </mat-checkbox>
    </mat-expansion-panel>
</ng-container>